import type { DialogTitleProps as MuiDialogTitleProps } from '@mui/material';
import { DialogTitle as MuiDialogTitle, SvgIcon } from '@mui/material';
import type { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import useStyles from './DialogTitle.styles';
import { IconButton } from '../button';
import CloseIcon from '@/ui/kit/icons/close.svg';
interface IDialogTitleProps extends MuiDialogTitleProps {
  onClose?: MouseEventHandler<HTMLButtonElement>;
  headerIcon?: ReactNode;
  hasBottomGutter?: boolean;
}
export type DialogTitleProps = PropsWithChildren<IDialogTitleProps>;
export function DialogTitle({
  onClose,
  headerIcon,
  children,
  hasBottomGutter = true,
  ...dialogTitleProps
}: DialogTitleProps) {
  const {
    classes,
    cx
  } = useStyles();
  return <MuiDialogTitle className={cx(classes.header, {
    [classes.hasBottomGutter]: hasBottomGutter
  })} {...dialogTitleProps} data-sentry-element="MuiDialogTitle" data-sentry-component="DialogTitle" data-sentry-source-file="DialogTitle.tsx">
      {onClose && <IconButton className={classes.startIcon} data-testid='dialog-close-icon' size='large' onClick={onClose}>
          <SvgIcon component={CloseIcon} />
        </IconButton>}
      <span className={classes.headerTitle} data-testid='dialog-title'>
        {children}
      </span>
      {headerIcon && <span className={classes.endIcon}>{headerIcon}</span>}
    </MuiDialogTitle>;
}